<template>
  <div>
    <datatable
      title="Settings"
      @edit_click="editClick"
      :fields="fields"
      :response="settingList"
      :is_createable="false"
      :show_delete="false">
    </datatable>
  </div>
</template>
<script>
// imports
import { mapActions, mapMutations, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'

// exports
export default {
  name: 'setting-list',
  created: function () {
    this.fetchSettings()
  },
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'Setting',
          value: 'var'
        },
        {
          name: 'Value',
          value: 'value'
        }
      ],
      booleanArr: ['OFFER_MODAL_APPLICANT_MESSAGE', 'RELATED_OFFERS_IS_EXACT_SKILLS']
    }
  },
  computed: {
    ...mapState('settings', ['settingList'])
  },
  methods: {
    editClick (data) {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminSettingForm',
        data,
        modal_title: `Edit Setting - ${data.var}`,
        isBoolean: this.booleanArr.includes(data.var)
      })
    },
    ...mapMutations('modals', ['create']),
    ...mapActions('settings', ['fetchSettings'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
